import { render, staticRenderFns } from "./gzhuizongMb.vue?vue&type=template&id=0035bca6&scoped=true&"
import script from "./gzhuizongMb.vue?vue&type=script&lang=js&"
export * from "./gzhuizongMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035bca6",
  null
  
)

export default component.exports